"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _luxon = require("luxon");

var _dateFormats = _interopRequireDefault(require("./constants/dateFormats"));

var _timeFormats = _interopRequireDefault(require("./constants/timeFormats"));

var DateTimeFormatter = /*#__PURE__*/function () {
  function DateTimeFormatter() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$timeZone = _ref.timeZone,
        timeZone = _ref$timeZone === void 0 ? 'Etc/UTC' : _ref$timeZone,
        _ref$dateFormat = _ref.dateFormat,
        dateFormat = _ref$dateFormat === void 0 ? _dateFormats["default"].MIDDLE_ENDIAN : _ref$dateFormat,
        _ref$timeFormat = _ref.timeFormat,
        timeFormat = _ref$timeFormat === void 0 ? _timeFormats["default"].TWELVE_HOUR : _ref$timeFormat,
        i18n = _ref.i18n;

    (0, _classCallCheck2["default"])(this, DateTimeFormatter);
    this.ianaTimeZone = new _luxon.IANAZone(timeZone);
    this.dateFormat = dateFormat;
    this.timeFormat = timeFormat;
    this.i18n = i18n;
  }

  (0, _createClass2["default"])(DateTimeFormatter, [{
    key: "isoToLuxonDateTime",
    value: function isoToLuxonDateTime(isoDateTime) {
      return _luxon.DateTime.fromISO(isoDateTime, {
        zone: this.ianaTimeZone
      });
    }
  }, {
    key: "getMonthName",
    value: function getMonthName(monthNumber) {
      var isShort = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return this.i18n.months[isShort ? 'short' : 'long'][monthNumber];
    }
  }, {
    key: "getWeekdayName",
    value: function getWeekdayName(weekdayNumber) {
      var isShort = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return this.i18n.weekdays[isShort ? 'short' : 'long'][weekdayNumber];
    }
  }, {
    key: "getMonthNames",
    value: function getMonthNames() {
      var _this = this;

      var isShort = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(function (monthNumber) {
        return _this.getMonthName(monthNumber, isShort);
      });
    }
  }, {
    key: "formatMonthDate",
    value: function formatMonthDate(isoDateTime) {
      var isShortMonthName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var luxonDateTime = this.isoToLuxonDateTime(isoDateTime);
      var day = luxonDateTime.day;
      var monthName = this.getMonthName(luxonDateTime.month, isShortMonthName);

      switch (this.dateFormat) {
        case _dateFormats["default"].LITTLE_ENDIAN:
          return "".concat(day, " ").concat(monthName);

        case _dateFormats["default"].BIG_ENDIAN:
        case _dateFormats["default"].MIDDLE_ENDIAN:
        default:
          return "".concat(monthName, " ").concat(day);
      }
    }
  }, {
    key: "formatDate",
    value: function formatDate(isoDateTime) {
      var luxonDateTime = this.isoToLuxonDateTime(isoDateTime);
      var day = luxonDateTime.day,
          month = luxonDateTime.month,
          year = luxonDateTime.year;
      var monthName = this.getMonthName(month);

      switch (this.dateFormat) {
        case _dateFormats["default"].LITTLE_ENDIAN:
          return "".concat(day, " ").concat(monthName, " ").concat(year);

        case _dateFormats["default"].BIG_ENDIAN:
          return "".concat(year, " ").concat(monthName, " ").concat(day);

        case _dateFormats["default"].MIDDLE_ENDIAN:
        default:
          return "".concat(monthName, " ").concat(day, ", ").concat(year);
      }
    }
  }, {
    key: "formatTime",
    value: function formatTime(isoDateTime) {
      var luxonDateTime = this.isoToLuxonDateTime(isoDateTime);

      if (this.timeFormat === _timeFormats["default"].TWENTY_FOUR_HOUR) {
        return luxonDateTime.toFormat('HH:mm');
      }

      return luxonDateTime.toFormat('h:mm a');
    }
  }, {
    key: "formatWeekdayDate",
    value: function formatWeekdayDate(isoDateTime) {
      var luxonDateTime = this.isoToLuxonDateTime(isoDateTime);
      var weekdayName = this.getWeekdayName(luxonDateTime.weekday, true);
      return "".concat(weekdayName, ", ").concat(this.formatDate(isoDateTime));
    }
  }, {
    key: "formatDateTime",
    value: function formatDateTime(isoDateTime) {
      var formattedDate = this.formatDate(isoDateTime);
      var formattedTime = this.formatTime(isoDateTime);
      return "".concat(formattedDate, ", ").concat(formattedTime);
    }
  }, {
    key: "formatDateTimeRange",
    value: function formatDateTimeRange(isoStartDateTime, isoEndDateTime) {
      var startDate = this.formatDate(isoStartDateTime);
      var endDate = this.formatDate(isoEndDateTime);
      var startTime = this.formatTime(isoStartDateTime);
      var endTime = this.formatTime(isoEndDateTime);

      if (startDate === endDate) {
        return "".concat(startDate, ", ").concat(startTime, " - ").concat(endTime);
      }

      return "".concat(startDate, ", ").concat(startTime, " - ").concat(endDate, ", ").concat(endTime);
    }
  }, {
    key: "formatTimeRange",
    value: function formatTimeRange(isoStartDateTime, isoEndDateTime) {
      var startTime = this.formatTime(isoStartDateTime);
      var endTime = this.formatTime(isoEndDateTime);
      return "".concat(startTime, " - ").concat(endTime);
    }
  }, {
    key: "getTimeZoneDisplayName",
    value: function getTimeZoneDisplayName() {
      var timeZoneName = this.i18n.timeZones[this.ianaTimeZone.zoneName];
      if (!timeZoneName) return '';

      var timeZoneOffset = _luxon.DateTime.fromObject({
        zone: this.ianaTimeZone
      }).toFormat('ZZ');

      return "(GMT".concat(timeZoneOffset, ") ").concat(timeZoneName);
    }
  }]);
  return DateTimeFormatter;
}();

exports["default"] = DateTimeFormatter;